(() => {
  const overlay = document.querySelector('.asa-pricing-drawer__overlay');
  const panel = document.getElementById('AsaPricingDrawerPanel');
  if (!overlay || !panel) return;

  const closeButton = panel.querySelector('.asa-pricing-drawer__close');
  let activeTrigger = null;

  function open(trigger) {
    activeTrigger = trigger || null;
    overlay.classList.add('is-open');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    activeTrigger?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('asa-pricing-drawer-open');
    closeButton?.focus();
  }

  function close() {
    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    activeTrigger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('asa-pricing-drawer-open');
    activeTrigger?.focus();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-asa-pricing-trigger]');
    if (trigger) {
      open(trigger);
      return;
    }
    if (event.target.closest('[data-asa-pricing-close]')) close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });
})();
